import { httpClient } from "@/helpers/httpClient";
export default class {
    resource = "/api/application/healthCheck";
    async getHealthCheck() {
        await httpClient.get(this.resource);
        return true;
    }
}
